<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-cliente/>
  </section>
</template>

<script>
  import OrcamentoPillerCliente from './piller/OrcamentoPillerCliente'

  export default {
    components: {OrcamentoPillerCliente},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormCliente.vue